import { render, staticRenderFns } from "./onSubFormRowChange-editor.vue?vue&type=template&id=2c3676e0&scoped=true"
import script from "./onSubFormRowChange-editor.vue?vue&type=script&lang=js"
export * from "./onSubFormRowChange-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3676e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3676e0')) {
      api.createRecord('2c3676e0', component.options)
    } else {
      api.reload('2c3676e0', component.options)
    }
    module.hot.accept("./onSubFormRowChange-editor.vue?vue&type=template&id=2c3676e0&scoped=true", function () {
      api.rerender('2c3676e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onSubFormRowChange-editor.vue"
export default component.exports